// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3MlHM","actions":"GroupTable_actions__2adoA","deleteModalFooter":"GroupTable_deleteModalFooter__38JDi"};